export default __webpack_public_path__ + "pi1-1QAAT/components/SocialProof/images/income-relevance-03d058aeb533348b800abeabd94a9796.svg";